import { Badge as UiBadge, type BadgeProps as UiBadgeProps } from '@ordo/ui/badge'
import { cn } from '@ordo/ui/cn'

// Kitchen-v2 status variants for temperature and diet pills. Applied as
// className overlays on top of @ordo/ui's default variant so the upstream
// primitive stays unmodified.
const KITCHEN_BADGE_VARIANTS = {
  hot: 'bg-rose-200 text-rose-700',
  'hot-soft': 'bg-amber-50 text-amber-700',
  chilled: 'bg-indigo-200 text-indigo-700',
  ambient: 'bg-stone-200 text-stone-700',
  vegetarian: 'bg-green-50 text-green-800',
  compostable: 'bg-emerald-100 text-emerald-800',
  'dairy-free': 'bg-violet-50 text-violet-800',
  info: 'bg-blue-50 text-blue-700',
  warning: 'bg-amber-100 text-amber-800',
} as const

type KitchenBadgeVariant = keyof typeof KITCHEN_BADGE_VARIANTS

export type BadgeProps = Omit<UiBadgeProps, 'variant'> & {
  variant?: UiBadgeProps['variant'] | KitchenBadgeVariant
}

export function Badge({ variant, className, ...rest }: BadgeProps) {
  if (variant && variant in KITCHEN_BADGE_VARIANTS) {
    return <UiBadge className={cn(KITCHEN_BADGE_VARIANTS[variant as KitchenBadgeVariant], className)} {...rest} />
  }
  return <UiBadge variant={variant as UiBadgeProps['variant']} className={className} {...rest} />
}

export { badgeVariants } from '@ordo/ui/badge'
